import axios from 'axios';

let apiURL = 'http://localhost:4000'

if(process.env.NODE_ENV === 'production') {
  apiURL = 'https://api.' + window.location.hostname;
}

let instance = axios.create({
  baseURL: apiURL,
  timeout: 30000,
  withCredentials: true
});

export default instance;



// WEBPACK FOOTER //
// ./src/app/res/axios.js